export default __webpack_public_path__ + "static/media/lock.21dc2301.svg";